import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft, Lock } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { WorkItemDetailView } from '@/features/Trainer/WorkItemDetail';

/**
 * One piece of work, every student against it — for the TPO.
 *
 * The trainer's own screen, not a summary of it. Two renderings of the same
 * evidence would drift, and a college reading one story while their trainer
 * acts on another is the failure this whole feature exists to prevent. So this
 * route renders WorkItemDetailView unchanged and lets it hide its own write
 * controls.
 *
 * It exists as a separate route only because the trainer route sits behind a
 * role guard that bounces org admins to /org — which is exactly what happened
 * when the work drawer linked there.
 */
export const Route = createFileRoute('/org/batches/$batchId/work-items/$assessmentId')({
  component: OrgWorkItemRoute,
});

function OrgWorkItemRoute() {
  const { batchId, assessmentId } = Route.useParams();

  return (
    <div className="space-y-3">
      <Button variant="ghost" size="sm" asChild className="-ml-2 h-7 gap-1.5 px-2 text-xs">
        <Link to="/org/batches/$batchId" params={{ batchId }} search={{ tab: 'integrity' }}>
          <ArrowLeft className="h-3.5 w-3.5" aria-hidden="true" />
          Back to integrity
        </Link>
      </Button>

      <div className="flex items-start gap-2.5 rounded-lg border bg-muted/50 px-3 py-2.5 text-xs leading-relaxed text-muted-foreground">
        <Lock className="mt-0.5 h-3.5 w-3.5 flex-none" aria-hidden="true" />
        <p>
          <span className="font-semibold text-foreground">Read-only.</span> The same view your
          trainer works from. Signals here are prompts to ask about, not findings — most turn out to
          be nothing.
        </p>
      </div>

      <WorkItemDetailView batchId={batchId} assessmentId={assessmentId} readOnly />
    </div>
  );
}
